import React from 'react';
import { assertNever } from '../../../utils/helpers';

import { museum } from '../../../data';
import { CStartGiftTranscriptDemo } from './c-start-gift-demo';
import { CStartGiftTranscriptBrighton } from './c-start-gift-brighton';
import { CStartGiftTranscriptMunch } from './c-start-gift-munch';
import { CStartGiftTranscriptCop26 } from './c-start-gift-cop26';


const Transcript = (museum.slug === 'demo') ? CStartGiftTranscriptDemo
                 : (museum.slug === 'brighton') ? CStartGiftTranscriptBrighton
                 : (museum.slug === 'munch') ? CStartGiftTranscriptMunch
                 : (museum.slug === 'mpu') ? CStartGiftTranscriptDemo
                 : (museum.slug === 'cop-26') ? CStartGiftTranscriptCop26
                 : assertNever(museum.slug);


const CStartGiftTranscript: React.FC = () => {
  return <Transcript />;
};

export {
  CStartGiftTranscript,
};
